import { IPredictedLineupsDetail } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidMatchPredictedLineups } from './typeguards';
import { CreatePredictedLineupDetailsInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { MatchPredictedLineupsQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';
import { transformFormationFields, transformTeam } from '../../../utils/formation/formation';
import { IGenericObject } from '../../../utils/tests';

export default (obj: MatchPredictedLineupsQuery): IPredictedLineupsDetail=> {
  if (isValidMatchPredictedLineups(obj)) {
    CreatePredictedLineupDetailsInputSchema().parse(obj.data.matchPredictedLineup, {reportInput: true});

    const { matchPredictedLineup } = obj?.data!;

      const {
        matchData,
        competitionId,
        teamId,
        predictedHpLink: ctaHpUrl,
        predictedSponsorLink,
        hasHeadshots,
      } = matchPredictedLineup;
      const { away, home, date, lmpLineupLink: ctaLmpLineupUrl, lmpLink: ctaLmpUrl } = matchData!;
      const playersInFormation: IGenericObject = transformFormationFields({
        away: transformTeam(away!),
        home: transformTeam(home!)
      }, false);

      const transformed: IPredictedLineupsDetail = {
        hasImage: hasHeadshots!,
        date: date!,
        competitionId,
        teamId,
        ctaHpUrl,
        ctaLmpUrl,
        ctaLmpLineupUrl,
        away: {
          ...transformTeam(away!),
          playersInFormation: playersInFormation?.away?.players ?? [],
        },
        home: {
          ...transformTeam(home!),
          playersInFormation: playersInFormation?.home?.players ?? [],
        },
        trackingData: intcmpMap.matchPredictedLineups,
        predictedSponsorLink: predictedSponsorLink || '',
      };

      return transformed;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchPredictedLineupsQuery object',
      data: obj
    });
  }
};
